import React from 'react'
import classNames from 'classnames'

import * as Icons from 'components/Utils/Icons'

const getSlackChannelIcon = ({ type }) => {
  switch (type) {
    case 'private':
      return <Icons.LockIcon />
    case 'public':
      return '#'
    case 'personal':
      return '@'
    default:
      return ''
  }
}

export default ({ title, type, onSelect, onSubmit }) => (
  <div
    className={classNames([
      'flexbox flexbox-row flexbox-align-center',
      'pointer no-outline',
      'font-weight-medium',
      'primary-on-focus primary-on-hover background-primary-shade-light-on-focus background-primary-shade-light-on-hover',
      'padding-horizontal-medium padding-vertical-normal',
    ])}
    tabIndex="-1"
    onKeyDown={event => {
      if (event.key === 'Enter') {
        event.preventDefault()
        onSubmit()
        return false
      }
    }}
    onClick={onSelect}
  >
    <div className="flexbox-grow ellipsis">
      <span>
        {getSlackChannelIcon({ type })}
        {title}
      </span>
    </div>
  </div>
)
